import React from 'react';

function Home() {
    return (
        <div style={{ padding: '20px' }}>
            <h1>Witaj w Aplikacji CRM</h1>
            <p>Zarządzaj swoimi klientami, zleceniami i pracownikami w jednym miejscu.</p>
        </div>
    );
}

export default Home;